module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img33.f102aca8.jpg";